import React from "react"
import {
  getArticleCategoryPath,
  getArticlePath,
  getBlogPath,
  getPagePath,
  getProductPath,
  getCategoryPath,
} from "./path"
import { InboundLink, OutboundLink } from "../components/link"

const MagicLink = props => {
  const item = props.item

  if (item) {
    if (item.link) {
      const anchor = props.customAnchor ? props.customAnchor : item.anchor
      const locale = props.locale ? props.locale : item.locale
      switch (item.link.model.apiKey) {
        case "product_category":
          return (
            <InboundLink to={getPagePath(item.link, locale)} {...props}>
              {anchor}
            </InboundLink>
          )
        case "product":
          return (
            <InboundLink to={getProductPath(item.link, locale)} {...props}>
              {anchor}
            </InboundLink>
          )
        case "page":
          return (
            <InboundLink to={getPagePath(item.link, locale)} {...props}>
              {anchor}
            </InboundLink>
          )
        case "blog_page":
          return (
            <InboundLink
              to={getBlogPath(locale)}
              variant={props.variant}
              sx={props.sx}
            >
              {anchor}
            </InboundLink>
          )
        case "article":
          return (
            <InboundLink
              to={getArticlePath(item.link, locale)}
              as={props.as}
              variant={props.variant}
              sx={props.sx}
            >
              {anchor}
            </InboundLink>
          )
        case "article_category":
          return (
            <InboundLink
              to={getArticleCategoryPath(item.link, locale)}
              as={props.as}
              variant={props.variant}
              sx={props.sx}
            >
              {anchor}
            </InboundLink>
          )
        default:
          return null
      }
    }
    return (
      <OutboundLink target="_blank" href={item.url} {...props}>
        {item.anchor}
      </OutboundLink>
    )
  } else {
    return <OutboundLink href="" {...props}></OutboundLink>
  }
}

export { MagicLink }
